import { useState, type MouseEvent } from "react";
import type { AdminUserRequestedFor } from "../../api/adminUsers";
import { AdminUserSitesModal } from "./AdminUserSitesModal";
import "./AdminUserSitesCell.scss";

const PREVIEW_COUNT = 3;

interface AdminUserSitesCellProps {
  sites?: AdminUserRequestedFor[];
  userLabel?: string;
}

const SiteEntry = ({ inn, siteUrl }: AdminUserRequestedFor) => (
  <div className="admin-users-table-site">
    <span className="admin-users-table-site-inn">{inn?.trim() || "—"}</span>
    <span className="admin-users-table-site-url" title={siteUrl?.trim() || undefined}>
      {siteUrl?.trim() || "—"}
    </span>
  </div>
);

export const AdminUserSitesCell = ({ sites, userLabel = "Пользователь" }: AdminUserSitesCellProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const items = sites ?? [];

  if (items.length === 0) {
    return <span className="admin-users-table-sites-empty">—</span>;
  }

  const hasMore = items.length > PREVIEW_COUNT;
  const previewItems = hasMore ? items.slice(0, PREVIEW_COUNT) : items;
  const hiddenCount = items.length - PREVIEW_COUNT;

  const handleOpenModal = (event: MouseEvent) => {
    event.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="admin-users-table-sites-cell">
        <div className="admin-users-table-sites-preview">
          {previewItems.map((site, index) => (
            <SiteEntry key={`${site.inn ?? "inn"}-${site.siteUrl ?? index}`} {...site} />
          ))}
        </div>

        {hasMore ? (
          <div className="admin-users-table-sites-footer">
            <span className="admin-users-table-sites-more">ещё {hiddenCount}</span>
            <button type="button" className="admin-users-table-sites-view-all" onClick={handleOpenModal}>
              Посмотреть все
            </button>
          </div>
        ) : null}
      </div>

      {isModalOpen ? (
        <AdminUserSitesModal
          sites={items}
          userLabel={userLabel}
          onClose={() => setIsModalOpen(false)}
        />
      ) : null}
    </>
  );
};
